var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("my-asidebar", { attrs: { "active-tab": "reports" } }),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "dashboard-area" },
        [
          _c("top-bar"),
          _vm._v(" "),
          _vm.dashboardUrl
            ? _c("iframe", {
                attrs: {
                  src: _vm.dashboardUrl,
                  frameborder: "0",
                  width: "1400",
                  height: "1200",
                  allowtransparency: "",
                },
              })
            : _c("h5", [
                _vm._v(
                  " Raporlama sistemi güncelleniyor lütfen 1 dakika sonra tekrar deneyiniz."
                ),
              ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }